export default __webpack_public_path__ + "static/carousel-13-353a553c040fc35301420f592883be00.jpg";